import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { DownloadLogsProgressResData } from "./DownloadLogsProgressResData";
import { DownloadLogsReqData } from "./DownloadLogsReqData";

const ENDPOINT = "/download_logs/force_on_demand";

export class ForceLogsDownloadOnDemandCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: DownloadLogsReqData = null;

    constructor(params: DownloadLogsReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<DownloadLogsProgressResData> {
        var res = await this.executeCommand(this.params);
        return new DownloadLogsProgressResData(res);
    }
}
